import { render } from "./ChangeOption.vue?vue&type=template&id=053b3b2a"
import script from "./ChangeOption.vue?vue&type=script&lang=js"
export * from "./ChangeOption.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__